module.exports = __webpack_public_path__ + "media/images/pages/peel-case/case-4-0a0c48e756efe513a89b8a925b1e8826.png";